// extracted by mini-css-extract-plugin
export default {"ScrollUpButton":"styles_ScrollUpButton__Tg-32"};